import ArcProgress from 'react-arc-progress';

const {round} = Math;

import {impactScoreText, impactScoreColor} from 'src/util/impact-score';

type Props = {
  score: number,
  size?: number,
}

const getSecondaryText = (size: number) => {
  if (size > 200 ) {
    return 'out of 100';
  } else if (size > 100) {
    return 'of 100';
  } else {
    return '';
  }
};


const calculateLargeTextSize = (size: number) => {
  if (size > 200) {
    return round(0.275 * size);
  } else if (size > 100) {
    return round(0.275 * size);
  } else {
    return round(0.4 * size);
  }
};

const calculateSmallTextSize = (size: number) => {
  if (size > 200) {
    return round(0.075 * size);
  } else if (size > 100) {
    return round(0.075 * size);
  } else {
    return round(0.095 * size);
  }
};

export const ImpactScore = ({
  score,
  size = 200,
}: Props) => {
  const largeTextSize = calculateLargeTextSize(size);
  const smallTextSize = calculateSmallTextSize(size);

  const secondaryTextPosition = {
    x: size / 2,
    y: 0.75 * size,
  };

  return (
    <ArcProgress
      className="impact-score-bar"
      progress={score}
      text={impactScoreText(score)}
      fillColor={impactScoreColor(score)}
      thickness={smallTextSize}
      size={size}
      textStyle={{
        size: '' + largeTextSize,
        font: `'Prompt', Verdana, sans-serif`,
      }}
      customText={[
        {
          text: getSecondaryText(size),
          size: '' + smallTextSize,
          font: `'Prompt\', Verdana, sans-serif`,
          x: secondaryTextPosition.x,
          y: secondaryTextPosition.y,
        },
      ]}
    />);
};
